import { render, staticRenderFns } from "./DevicesDetails.vue?vue&type=template&id=0821cd89&"
import script from "./DevicesDetails.vue?vue&type=script&lang=js&"
export * from "./DevicesDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports